import React from 'react';

import Footer from 'wanderu-component-footer';

import loadTranslation from '../../utils/loadTranslation';

const locale = 'en-us';

function FooterPage() {
    return (
        <Footer
            rootUrl="https://www.wanderu.com/"
            isExternal
        />
    );
}

FooterPage.serverFetchData = async function({ i18nCoordinator }) {
    await loadTranslation({ i18nCoordinator, locale, currency: 'USD' });
};

export default FooterPage;
